import React from 'react'
import styled from 'styled-components'

import { TOKEN_LIST } from '../lib/tokenList'

type Props = {
  onChange: (token: string) => void
  address?: string
}

const Container = styled.div`
  padding: 4px;
  display: flex;
  gap: 0.5rem;
  color: #fff;
  font-size: 0.8rem;
  padding: 0;
  flex-wrap: wrap;
`

const Pill = styled.button<{selected: boolean}>`
  border-radius: 1rem;
  padding: 0.5rem 1rem;
  transition: all .1s ease-in-out;
  cursor: pointer;
  background: #dd2967;
  white-space: nowrap;
  flex: 1 0 25%;
  border: 0;
  color: #fff;
  
  @media(min-width: 640px) {
    flex: 1;
  }

  &:hover {
    background: #ef3d7a;
  }

  ${({ selected }) => selected ? `
    background: #ffac4c;
    color: #292e49;
  
    &:hover {
      background: #ffb764;
    }
  ` : ``}
`

export const ExampleTokens: React.FC<Props> = ({
  address,
  onChange
}: Props) => {
  return (
    <Container>
      {TOKEN_LIST.map((token) => (
        <Pill
          key={token.address}
          selected={token.address === address}
          onClick={() => onChange?.(token.address)}
        >{token.name}</Pill>
      ))}
    </Container>
  )
}
